import { WarningAmberRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  Chip,
  Grid,
  LinearProgress,
  Stack,
  Typography
} from '@mui/material';

interface Props {
  quotaUsed: number;
  quota: number;
  contactLink: string;
}

const QuotaWarning = ({ quotaUsed, quota, contactLink }: Props) => (
  <Grid item lg={12}>
    <Box
      sx={{
        mb: 3,
        p: 2,
        borderRadius: '8px',
        backgroundColor: '#FFF1F2',
        border: '1px solid #FDA4AF'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            backgroundColor: '#FFE4E6',
            color: '#E11D48',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          <WarningAmberRounded fontSize="small" />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
              mb: 0.5
            }}
          >
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 800,
                color: '#9F1239'
              }}
            >
              Clipping quota has been reached
            </Typography>

            <Chip
              label={`${quotaUsed} / ${quota} used`}
              size="small"
              sx={{
                backgroundColor: '#FFE4E6',
                color: '#9F1239',
                fontWeight: 700,
                fontSize: 12
              }}
            />
          </Box>

          <Typography
            sx={{
              fontSize: 13,
              color: '#9F1239',
              lineHeight: 1.6,
              mb: 1.5
            }}
          >
            You cannot create a new Auto Clipping because all available
            clipping quota has been used. Please remove an existing clipping
            object or upgrade your quota to continue.
          </Typography>

          <LinearProgress
            variant="determinate"
            value={(quotaUsed / quota) * 100}
            sx={{
              height: 7,
              borderRadius: 99,
              backgroundColor: '#FECDD3',
              mb: 1.5,
              '& .MuiLinearProgress-bar': {
                borderRadius: 99,
                backgroundColor: '#E11D48'
              }
            }}
          />

          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                borderRadius: '8px',
                borderColor: '#E11D48',
                color: '#E11D48',
                fontWeight: 700,
                '&:hover': {
                  borderColor: '#BE123C',
                  backgroundColor: '#FFF1F2'
                }
              }}
              onClick={() => window.open(contactLink, '_blank')}
            >
              Contact Us
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  </Grid>
);

export default QuotaWarning;
